import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { SegmentTrackEvent } from '@ninety/platform/models/analytics/segment/segment-track-event.enum';
import { SegmentActions } from '@ninety/platform/state/app-global/analytics/segment/segment.actions';

import { LearnSupportMenuActions } from '../main-layout/learn-support-menu/learn-support-menu.actions';

import { MainSidebarActions } from './main-sidebar/main-sidebar-state.actions';
import { UniversalCreateActions } from './universal-create/universal-create.actions';

@Injectable()
export class LayoutAnalyticsEffects {
  private readonly actions$ = inject(Actions);

  trackProfessionalServicesClicked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LearnSupportMenuActions.professionalServicesClicked),
      map(() => SegmentActions.track({ event: SegmentTrackEvent.PROFESSIONAL_SERVICES_CLICKED }))
    )
  );

  trackHelpCenterClicked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LearnSupportMenuActions.helpCenterClicked),
      map(() => SegmentActions.track({ event: SegmentTrackEvent.HELP_CENTER_CLICKED }))
    )
  );

  trackLiveTrainingClicked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LearnSupportMenuActions.liveTrainingClicked),
      map(() => SegmentActions.track({ event: SegmentTrackEvent.LIVE_TRAINING_CLICKED }))
    )
  );

  trackProductUpdatesClicked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LearnSupportMenuActions.productUpdatesClicked),
      map(() => SegmentActions.track({ event: SegmentTrackEvent.PRODUCT_UPDATES_CLICKED }))
    )
  );

  trackSupportContacted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LearnSupportMenuActions.supportContacted),
      map(() => SegmentActions.track({ event: SegmentTrackEvent.SUPPORT_CONTACTED }))
    )
  );

  trackGlobalCreateClicked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UniversalCreateActions.globalCreateButtonClicked),
      map(() => SegmentActions.track({ event: SegmentTrackEvent.GLOBAL_CREATE_CLICKED }))
    )
  );

  trackMainNavigationToggled$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MainSidebarActions.toggled),
      map(({ expanded }) =>
        SegmentActions.track({ event: SegmentTrackEvent.MAIN_NAVIGATION_TOGGLED, params: { expanded } })
      )
    )
  );
}
